// API
// ----------------------------------------------------------------------
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDlJu3ln7vyMHF7XkW_a9kJpfkvzQQ64XM';
export const GOOGLE_BUSINESS_PLACE_ID = 'ChIJb42dNDMXHxURQb0oGgt3Vn8';
export const API_BASE_URL = 'https://staging-api.cartify.org';
